const recentRoutes: string[] = []
const maxRoutes = 10

const sanitizeRoutePath = (route: string) => {
  const [withoutHash] = route.split('#')
  const [path] = withoutHash.split('?')
  return path
}

export const recordRoute = (route: string) => {
  if (!route) return
  const sanitizedRoute = sanitizeRoutePath(route)
  if (!sanitizedRoute) return
  const last = recentRoutes[recentRoutes.length - 1]
  if (last === sanitizedRoute) return
  recentRoutes.push(sanitizedRoute)
  if (recentRoutes.length > maxRoutes) {
    recentRoutes.splice(0, recentRoutes.length - maxRoutes)
  }
}

export const getRecentRoutes = () => [...recentRoutes]
